import { ListHeader } from 'components/molecules/ListHeader';

export const CrawlerListHeader = () => (
  <ListHeader
    columns={['クローラーID', 'クローラー名', 'イメージ名']}
    templateColumns="1fr 2fr 3fr"
  />
);
